module.exports = __webpack_public_path__ + "static/media/edit-item.4d9bf6cd.png";